import { notenOptions } from "../../data/noten";

class SchuelerSchema {
  constructor(klausur) {

    this.klausur = klausur;
    this.fields = {
      vorname: {
        name: "vorname",
        type: "string",
        fieldType: "text",
        label: "Vorname",
        col: 6,
        required: true,
        sort: 2,
        validation: {
          minLength: 1,
        },
      },
      nachname: {
        name: "nachname",
        type: "string",
        fieldType: "text",
        label: "Nachname",
        col: 6,
        required: true,
        sort: 3,
        validation: {
          minLength: 1,
        },
      },
      leseschwaeche: {
        name: "leseschwaeche",
        type: "boolean",
        fieldType: "checkBox",
        label: "Lese- /Rechtschreibschwierigkeit (nur bei Notenschutz)",
        col: 4,
        sort: 4,
      },

      afb1Points: {
        name: "afb1Points",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 6,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      afb1Tb: {
        name: "afb1Tb",
        type: "string",
        fieldType: "text",
        label: "AFB I: Problemerfassung und Sacherschließung",
        col: 11,
        required: true,
        sort: 7,
        validation: {
          minLength: 1,
        },
      },
      afb1Remarks: {
        name: "afb1Remarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zu AFB I",
        col: 12,
        sort: 8,
      },
      afb2Points: {
        name: "afb2Points",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 9,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      afb2Tb: {
        name: "afb2Tb",
        type: "string",
        fieldType: "text",
        label: "AFB II: Problem- und Sachanalyse",
        col: 11,
        required: true,
        sort: 10,
        validation: {
          minLength: 1,
        },
      },
      afb2Remarks: {
        name: "afb2Remarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zu AFB II",
        col: 12,
        sort: 11,
      },
      afb3Points: {
        name: "afb3Points",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 12,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      afb3Tb: {
        name: "afb3Tb",
        type: "string",
        fieldType: "text",
        label: "AFB III: Urteil",
        col: 11,
        required: true,
        sort: 13,
        validation: {
          minLength: 1,
        },
      },
      afb3Remarks: {
        name: "afb3Remarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zu AFB III",
        col: 12,
        sort: 14,
      },
      sprachePoints: {
        name: "sprachePoints",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 15,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      spracheTb: {
        name: "spracheTb",
        type: "string",
        fieldType: "text",
        label: "Sprachverwendung",
        col: 11,
        required: true,
        sort: 16,
        validation: {
          minLength: 1,
        },
      },
      spracheRemarks: {
        name: "spracheRemarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zur Sprachverwendung",
        col: 12,
        sort: 17,
      },
      spracheKorrektPoints: {
        name: "spracheKorrektPoints",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 18,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      spracheKorrektTb: {
        name: "spracheKorrektTb",
        type: "string",
        fieldType: "text",
        label: "Sprachliche Korrektheit",
        col: 11,
        required: true,
        sort: 19,
        validation: {
          minLength: 1,
        },
      },
      spracheKorrektRemarks: {
        name: "spracheKorrektRemarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zur sprachlichen Korrektheit",
        col: 12,
        sort: 20,
      },
      spracheAusdruckPoints: {
        name: "spracheAusdruckPoints",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 21,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      spracheAusdruckTb: {
        name: "spracheAusdruckTb",
        type: "string",
        fieldType: "text",
        label: "Sprachlicher Ausdruck",
        col: 11,
        required: true,
        sort: 22,
        validation: {
          minLength: 1,
        },
      },
      spracheAusdruckRemarks: {
        name: "spracheAusdruckRemarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zum sprachlichen Ausdruck",
        col: 12,
        sort: 23,
      },
      spracheLesenPoints: {
        name: "spracheLesenPoints",
        type: "string",
        fieldType: "select",
        label: "Punkte",
        col: 1,
        required: true,
        sort: 24,
        validation: {
          maxLength: 2,
          minLength: 2,
        },
        options: notenOptions,
      },
      spracheLesenTb: {
        name: "spracheLesenTb",
        type: "string",
        fieldType: "text",
        label: "Lesefreundliche Form",
        col: 11,
        required: true,
        sort: 25,
        validation: {
          minLength: 1,
        },
      },
      spracheLesenRemarks: {
        name: "spracheLesenRemarks",
        type: "string",
        fieldType: "textarea",
        label: "Bemerkungen zur lesefreundlichen Form",
        col: 12,
        sort: 26,
      },
      zusammenfassung: {
        name: "zusammenfassung",
        type: "string",
        fieldType: "textarea",
        label: "Zusammenfassung",
        col: 12,
        sort: 27,
      },
    };
    this.conditions = {
      keys: [
        "vorname",
        "nachname",
        "leseschwaeche",
        "afb1Points",
        "afb1Tb",
        "afb1Remarks",
        "afb2Points",
        "afb2Tb",
        "afb2Remarks",
        "afb3Points",
        "afb3Tb",
        "afb3Remarks",
        "sprachePoints",
        "spracheTb",
        "spracheRemarks",
        "spracheKorrektPoints",
        "spracheKorrektTb",
        "spracheKorrektRemarks",
        "spracheAusdruckPoints",
        "spracheAusdruckTb",
        "spracheAusdruckRemarks",
        "spracheLesenPoints",
        "spracheLesenTb",
        "spracheLesenRemarks",
        "zusammenfassung",
      ],
      laender: {
        Berlin: {
          deleteFields: [
            "spracheKorrektPoints",
            "spracheKorrektTb",
            "spracheKorrektRemarks",
            "spracheAusdruckPoints",
            "spracheAusdruckTb",
            "spracheAusdruckRemarks",
            "spracheLesenPoints",
            "spracheLesenTb",
            "spracheLesenRemarks",
          ],
        },
        Brandenburg: {
          deleteFields: ["sprachePoints", "spracheTb", "spracheRemarks"],
        },
      },
      pruefungsart: {
        a: { deleteFields: ["halbjahr", ] },
        an: { deleteFields: ["halbjahr", ] },
      },
      kursart: {
        g: { deleteFields: [] },
      },
    };
  }
  getFields(companies, klausur) {
    const keys = Object.keys(this.fields);
    const company = companies.find(
      (c) => c.id === parseInt(klausur.companyId)
    );
    // console.log({companies, company, klausur},company?.land)
    if(!company) return this.fields;
    const { land} = company;
    const { kursart, pruefungsart} = klausur;
    const deleteFieldsLand = this.conditions.laender[land]?.deleteFields || [];
    const deleteFieldsPruefungsart =
      this.conditions.pruefungsart[pruefungsart]?.deleteFields || [];
    const deleteFieldsKursart =
      this.conditions.kursart[kursart]?.deleteFields || [];
    const deleteFieldsAll = [
      ...deleteFieldsLand,
      ...deleteFieldsPruefungsart,
      ...deleteFieldsKursart,
    ];
    const activeKeys = keys.filter((k) => !deleteFieldsAll.includes(k));
    const fields = {};
    activeKeys.forEach((k) => (fields[k] = this.fields[k]));
    // console.log({
    //   deleteFieldsPruefungsart,
    //   deleteFieldsLand,
    //   deleteFieldsKursart,
    //   deleteFieldsAll,
    //   land,
    //   company,
    //   keys,
    //   kursart,
    //   keys,
    //   activeKeys,
    //   fields,
    // });
    return fields;
  }
}
export default SchuelerSchema;
